import type { PropertiesTableProps } from '../../shared/types'
import { SharedValueProperties } from './StatDocsUtils'

export const PercentProperties: PropertiesTableProps =
  SharedValueProperties
